export default "__VITE_ASSET__B6M3ZHI9__"